/**
 * Simple count of stories over the previous 24 hours
 * @author Ryan Gladstone
 * <viz-pitch-percentage></viz-pitch-percentage>
 * Webpack migration by Umer Hassan
 */

function vizPitchPercentageController($scope, $translate, statsService, $log) {
  const endTime = Math.floor(Date.now() / 1000);
  const startTime = endTime - (3600 * 24);


  function storyCountError() {
    $scope.pitchPercent = $translate.instant('ERROR');
    $scope.pitchPercentLabel = $translate.instant('STORIES_PITCHED');
  }

  statsService.getBreakdown('pitching', startTime, endTime,
    $scope.filterSet.getFilterValue('sections'),
    $scope.filterSet.getFilterValue('platforms')
  )
    .then((data) => {
      // Check to make sure two numbers came back
      if (data[0] && data[0].count >= 0 && data[1] && data[1].count >= 0) {
        // check to see if there were any stories
        if (data[0].count > 0 && data[1].count > 0) {
          // if so, calculate the pitched percentage
          $scope.pitchPercent = `${Math.round((data[0].count / (data[0].count + data[1].count)) * 100)}%`;
        } else {
          // no stories == no pitches
          $scope.pitchPercent = '0%';
        }
        $scope.pitchPercentLabel = $translate.instant('STORIES_PITCHED');

        // if not, throw an error
      } else {
        storyCountError();
      }
    }, (response) => {
      $log.error('vizPitchPercentageCtrl() error: ', response);
      storyCountError();
    });
}

function directive() {
  return {
    restrict: 'E',
    scope: {
      filterSet: '='
    },
    template: '<h4>{{ pitchPercent }}</h4>{{ pitchPercentLabel }}',
    controller: ['$scope',
      '$translate',
      'statsService',
      '$log',
      vizPitchPercentageController]
  };
}

export default function (ngModule) {
  ngModule.directive('vizPitchPercentage', directive);
}
